export default __webpack_public_path__ + "static/media/225.d83f80e8.gif";